import React from "react";

function Appointment() {
  return <div className="section-container">Termin vereinbaren</div>;
}

export default Appointment;
